// extracted by mini-css-extract-plugin
module.exports = {"container":"Metadata_container__7eihg","metadata":"Metadata_metadata__qBxF4"};